var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.007 11.682c-.3-.239-.605-.461-.89-.714C1.375 10.316.76 9.536.381 8.544c-.613-1.607-.475-3.159.33-4.634.833-1.53 2.07-2.486 3.52-3.096 2.402-1.01 4.833-1.06 7.262-.13 1.422.544 2.66 1.417 3.579 2.811a5.545 5.545 0 01-.222 6.453c-1.172 1.536-2.688 2.37-4.388 2.83-1.187.32-2.39.373-3.603.252-.103-.01-.236.064-.32.145a9.47 9.47 0 01-4.427 2.428c-.15.036-.304.058-.456.084-.193.032-.35-.028-.449-.234a.52.52 0 01.06-.564c.142-.197.287-.393.443-.574a6.033 6.033 0 001.297-2.633z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default ForwardRef;